import { useEffect } from "react";
import { BRAND } from "../brand";

const upsertMeta = (selector, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    Object.entries(attrs).forEach(([k, v]) => {
      if (k !== "content") el.setAttribute(k, v);
    });
    document.head.appendChild(el);
  }
  el.setAttribute("content", attrs.content);
};

export const Seo = ({
  title,
  description,
  path = "/",
  image = "/brand/hero-portrait.png",
  type = "website",
  jsonLd = null,
}) => {
  useEffect(() => {
    const url = `${BRAND.siteUrl}${path}`;
    const absImage = image.startsWith("http") ? image : `${BRAND.siteUrl}${image}`;
    const fullTitle = title.toLowerCase().includes("ooloo")
      ? title
      : `${title} | ooloo — your daily kitchen partner`;

    document.title = fullTitle;

    upsertMeta('meta[name="description"]', {
      name: "description",
      content: description,
    });
    upsertMeta('meta[name="keywords"]', {
      name: "keywords",
      content:
        "kitchen help Lucknow, kitchen helper Gomtinagar, on-demand cook Lucknow, chopped vegetables Lucknow, freshly blended spices Lucknow, kitchen executive Lucknow, daily kitchen support Sushant Golf City, home cooking help Lucknow",
    });

    upsertMeta('meta[property="og:title"]', { property: "og:title", content: fullTitle });
    upsertMeta('meta[property="og:description"]', { property: "og:description", content: description });
    upsertMeta('meta[property="og:url"]', { property: "og:url", content: url });
    upsertMeta('meta[property="og:type"]', { property: "og:type", content: type });
    upsertMeta('meta[property="og:image"]', { property: "og:image", content: absImage });
    upsertMeta('meta[property="og:site_name"]', { property: "og:site_name", content: "ooloo" });
    upsertMeta('meta[property="og:locale"]', { property: "og:locale", content: "en_IN" });

    upsertMeta('meta[name="twitter:card"]', { name: "twitter:card", content: "summary_large_image" });
    upsertMeta('meta[name="twitter:title"]', { name: "twitter:title", content: fullTitle });
    upsertMeta('meta[name="twitter:description"]', { name: "twitter:description", content: description });
    upsertMeta('meta[name="twitter:image"]', { name: "twitter:image", content: absImage });

    let linkEl = document.head.querySelector('link[rel="canonical"]');
    if (!linkEl) {
      linkEl = document.createElement("link");
      linkEl.setAttribute("rel", "canonical");
      document.head.appendChild(linkEl);
    }
    linkEl.setAttribute("href", url);

    const prev = document.head.querySelector("script[data-seo-jsonld]");
    if (prev) prev.remove();
    if (jsonLd) {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-seo-jsonld", "1");
      s.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(s);
    }
  }, [title, description, path, image, type, jsonLd]);

  return null;
};
